import request from '@/utils/request'

let HomepopupApi = {
  /*获取数据*/
  getData(data) {
    return request._get('/shop/plus.homepopup/index', data);
  },
  /*保存数据*/
  saveData(data) {
    return request._post('/shop/plus.homepopup/index', data);
  },
}
export default HomepopupApi;



// WEBPACK FOOTER //
// ./src/api/homepopup.js